import { statusColorRenderer } from "../../util/helper/helperFunctions";
import "../../assets/css/LgvPopup/LgvPopup.css";

const renderIconType = (status, nonLGVRotation, alarmName) => {
  // alarmName = "LGV In Manual";
  if (status === "white") {
    return {
      backgroundColor: "white",
      color: "black",
      transform: nonLGVRotation ? "rotate(90deg)" : "none"
    };
  } else if (status === "Alarm" && alarmName === "LGV In Manual") {
    return {
      backgroundColor: statusColorRenderer("LGV In Manual")
    };
  } else {
    return {
      backgroundColor: statusColorRenderer(status)
    };
  }
};

const LgvIcon = ({
  data,
  status,
  className,
  isFollowing,
  nonLGVRotation,
  alarmName
}) => (
  <>
    <span
      style={renderIconType(status, nonLGVRotation, alarmName)}
      className={className ?? "lgv-icon-style" + " " + status}
    >
      {data}
    </span>
    {isFollowing && (
      <span id="lgv-wrapper-circle">
        <span className="lgv-wrapper-circle-outer"></span>
        <span className="lgv-wrapper-circle-inner"></span>
      </span>
    )}
  </>
);

export default LgvIcon;
